import $ from 'jquery';

// Cached DOM Elements
let windowSize = $(window).width();
const $megaNav = $('.mega-nav');
const $openSearch = $megaNav.find('#openSearch');
const $inputSearch = $megaNav.find('#searchInput');
const $searchResults = $('body').find('.search_btn');

const $menu = $megaNav.find('.mega-nav__menu');
const $items = $megaNav.find('.mega-nav__items');
const $hamburger = $megaNav.find('.hamburger');
const $menuItem = $menu.find('.mega-nav__menu--parent');
const $subitems = $megaNav.find('.mega-nav__subitems');
const megaNavPosition = ($megaNav && $megaNav.length > 0) ?? $megaNav.offset().top;
let navHeight = $megaNav.height();

const redirectSearch = (parameters) => {
    const url = '/search?searchTerms=' + parameters;
    window.location = url;
};

/**
 * @method eventHandlers
 * Contains all DOM events
 */
const eventHandlers = () => {

    // Set values on resize for correct rendering
    $(window).on('resize', function(){
        navHeight = $megaNav.height();
        windowSize = $(window).width();
    });

    // Scroll events for navigation
    $(window).on('scroll', function(){
        const windowPosition = $(window).scrollTop();
        if (windowPosition > megaNavPosition) {
            $megaNav.addClass('mega-nav--sticky');
            $('html').css('padding-top', navHeight);
        } else {
            $megaNav.removeClass('mega-nav--sticky');
            $('html').css('padding-top', '0');
        }
    })

    // Mobile menu logic
    $hamburger.on('click', function(){
        $(this).toggleClass('hamburger--open');
        $items.toggleClass('mega-nav__items--open');
    });

    // Search button logic
    $openSearch.on('click', function(){
        $items.toggleClass('mega-nav__items--search');
        $inputSearch.focus();
    });

    // On search click
    $searchResults.on('click', function(){
        $items.toggleClass('mega-nav__items--search');
        if ($(this).prev().val() !== '') {
            redirectSearch($(this).prev().val());
        }
    });

    // On search keypress
    $inputSearch.on('keypress', function(event){
        const keycode = (event.keyCode ? event.keyCode : event.which);
        if (keycode == '13' && $(this).val() !== '') {
            redirectSearch($(this).val());
        }
    });

     // Document handlers
     $(document).on('click', function(e) {
        const $container = $('.mega-nav__search');
        const $target = $(e.target);

        // Mobile nav logic
        if ($target.parents('.mm-navbar').length && $target.hasClass('search__btn')) {
            if ($target.prev().val() !== '') {
                redirectSearch($target.prev().val());
            }
        }

        // Close search on click outside
        if (!$target.parents('.mega-nav__search').length && !$target.parents('.mega-nav__search-icon').length) {
            $container.parents('.mega-nav__items').removeClass('mega-nav__items--search');
        }
    });

    // Open menu on mouse over event
    $menuItem.on('mouseover', function(){
        if (windowSize > 1024) {
            $subitems.find('.container').hide();
            const $subItem = $(this).next().find('.mega-nav__subitems--wrapper');
            $subItem.show();
        }
    });

    // Close menu on mouse leave event
    $('.mega-nav__menu--parent').parent().on('mouseleave', function(){
        if (windowSize > 1024) {
            $subitems.find('.container').hide();
        }
    });
};

/**
 * @method mmenuInit
 * Initialize mmenu in mobile
 */
const mmenuInit = () => {
    // mmenu init
    const menu = new Mmenu('#menu', {
        slidingSubmenus: true,
        offCanvas: { position: 'right'},
        navbars: [
            {
                position: 'top',
                content: [
                    "<div><input type='text' class='search' placeholder='Search' /><button class='search__btn'></button></div>"
                ]
            }
        ]
    });
}

/**
 * @method init
 * Initialize events during page load
 */
const init = (() => {
    if ($megaNav.length) {
        document.addEventListener("DOMContentLoaded", () => {
            mmenuInit();
            eventHandlers();
        });
    }
})();